import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class loading extends Component {
  state = {
    loading: false
  };
  componentWillReceiveProps(next) {
    if (!next.products && !next.orders && !next.brands && !next.customer) {
      document.body.classList.remove("modal-open");
      this.setState({ loading: false });
    } else {
      document.body.classList.add("modal-open");
      this.setState({ loading: true });
    }
  }

  render() {
    return (
      <>
        {!this.state.loading ? (
          ""
        ) : (
          <div
            tabIndex="-1"
            style={{ position: "relative", zIndex: 1050, display: "block" }}
          >
            <div className="">
              <div
                className="modal fade show"
                role="dialog"
                tabIndex="-1"
                style={{ display: "block" }}
              >
                <div className="modal-dialog my-custom-modal" role="document">
                  <div
                    className="d-flex justify-content-center"
                    style={{ paddingTop: "50%" }}
                  >
                    <div
                      className="spinner-border text-danger loading-style"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show" />
            </div>
          </div>
        )}
      </>
    );
  }
}

loading.propTypes = {
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  products: state.products.isFetching,
  orders: state.orders.isFetching,
  brands: state.brands.isFetching,
  customer: state.customer.isFetching
});

export default connect(
  mapStateToProps,
  {}
)(loading);
